// invoice.test lo entrega el backend en /catalogue/shoppingcart/find: 1 = prueba, 2 = produccion.
// Devuelve null cuando el dato no viene, para poder distinguirlo de una transaccion real.
export const parseInvoiceTest = (value: any): boolean | null => {
    if (value === undefined || value === null || value === '') return null;
    if (typeof value === 'boolean') return value;
    const normalized = String(value).trim().toUpperCase();
    if (normalized === '1' || normalized === 'TRUE') return true;
    if (normalized === '2' || normalized === '0' || normalized === 'FALSE') return false;
    return null;
};

// x_test_request llega como "TRUE"/"FALSE" (string) o booleano segun el medio de pago.
// Devuelve null cuando el dato no viene, para poder distinguirlo de una transaccion real.
export const parseTestRequest = (value: any): boolean | null => {
    if (value === undefined || value === null || value === '') return null;
    if (typeof value === 'string') return value.trim().toUpperCase() === 'TRUE';
    return Boolean(value);
};